import type {
  TopContracts,
  TopMonths,
  TopPositions,
} from "@/features/companyDetail/components/shared/RecruitmentPatternInformation/utils/analyticsUtils"
import type { CompanyAnalytics } from "@/modules/companies/api/types"

import {
  getHasEnoughData,
  getThreeTopMonths,
  getTopContracts,
  getTopPositions,
} from "@/features/companyDetail/components/shared/RecruitmentPatternInformation/utils/analyticsUtils"
import { useCompanyAnalyticsFetch } from "@/features/companyDetail/hooks/useCompanyAnalyticsFetch"

export type UseCompanyAnalyticsData = {
  hasEnoughData: boolean
  topPositions: TopPositions
  topContract: TopContracts
  topMonths: TopMonths
}

export const useCompanyAnalyticsData = (): UseCompanyAnalyticsData => {
  const { dataCompanyAnalytics } = useCompanyAnalyticsFetch()
  const hasEnoughData = getHasEnoughData(dataCompanyAnalytics)

  return {
    hasEnoughData,
    topContract: hasEnoughData ? getTopContracts(dataCompanyAnalytics as CompanyAnalytics) : null,
    topMonths: hasEnoughData ? getThreeTopMonths(dataCompanyAnalytics as CompanyAnalytics) : null,
    topPositions: hasEnoughData ? getTopPositions(dataCompanyAnalytics as CompanyAnalytics) : null,
  }
}
